<div class="authenticating">
  <i class="fa fa-user-check fa-3x"></i>
  <br />
  Authenticating&hellip;
</div>
